import { render, staticRenderFns } from "./SurgeriesTable.vue?vue&type=template&id=7d576f96&"
import script from "./SurgeriesTable.vue?vue&type=script&lang=js&"
export * from "./SurgeriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports